// settings.guard.ts
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '../feature/services/settings.service';

export const settingsGuard = () => {
  const settingsService = inject(SettingsService);
  const router = inject(Router);

  if (!settingsService.hasRequiredSettings()) {
    router.navigate(['/admin/settings']);
    return false;
  }

  return true;
};

export const eKomunikacijaGuard = () => {
  const settingsService = inject(SettingsService);
  const router = inject(Router);

  if (!settingsService.hasEkomunikacijaSettings()) {
    router.navigate(['/admin/settings']);
    return false;
  }

  return true;
};
